function getRangeValues(currentFrom, currentTo) {
  const from = Math.round(Number(currentFrom.value.replace(',', '')));
  const to = Math.round(Number(currentTo.value.replace(',', '')));
  return [from, to];
}

function controlRangeFrom(fromSlider, rangeValues) {
  const [from, to] = rangeValues;
  if (from > to) {
    fromSlider.value = from;
  } else if (from === 0) {
    fromSlider.value = fromSlider.min;
  } else {
    fromSlider.value = from;
  }
}

function controlRangeTo(toSlider, rangeValues) {
  const [from, to] = rangeValues;
  if (from <= to && to !== 0) {
    toSlider.value = to;
  } else if (to === 0) {
    toSlider.value = toSlider.max;
  } else {
    toSlider.value = from;
  }
}

function addRangeListeners() {
  const priceRangeFrom = document.querySelectorAll(
    '[data-price-range-slider-from]'
  );
  const priceRangeTo = document.querySelectorAll(
    '[data-price-range-slider-to]'
  );

  priceRangeFrom.forEach((_, index) => {
    priceRangeFrom[index].oninput = () => {
      const priceRange = priceRangeFrom[index].closest(
        '.price-range-slider-wrapper'
      )?.nextElementSibling;
      const priceRangeInputs = priceRange.querySelectorAll('input');

      controlRangeFrom(
        priceRangeFrom[index],
        getRangeValues(priceRangeFrom[index], priceRangeTo[index])
      );

      priceRangeInputs[0].value = new Intl.NumberFormat('en-GB', {
        style: 'decimal'
      }).format(Number(priceRangeFrom[index].value));
    };
  });

  priceRangeTo.forEach((_, index) => {
    priceRangeTo[index].oninput = () => {
      const priceRange = priceRangeTo[index].closest(
        '.price-range-slider-wrapper'
      )?.nextElementSibling;
      const priceRangeInputs = priceRange.querySelectorAll('input');

      controlRangeTo(
        priceRangeTo[index],
        getRangeValues(priceRangeFrom[index], priceRangeTo[index])
      );

      priceRangeInputs[1].value = new Intl.NumberFormat('en-GB', {
        style: 'decimal'
      }).format(Number(priceRangeTo[index].value));
    };
  });
}
addRangeListeners();
